import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

import Panel from './components/Panel';
import { breakpoints, customEvents, weatherIconMap } from '../../helpers/constants';

const WeatherWidget = ({ endpoint, ...props }) => {
  const breakpoint = window.matchMedia(
    `(min-width: ${breakpoints.tabletLandscape}px)`
  );
  const [isOpen, setIsOpen] = useState(false);
  const [report, setReport] = useState({});
  const [selectedUnit, setSelectedUnit] = useState(
    window.localStorage.getItem('aspen_weather_unit') || 'f'
  );

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await Axios({
        method: 'GET',
        url: endpoint
      });

      setReport(data);
    };

    fetchData();
  }, [endpoint]);

  useEffect(() => {
    if (isOpen) {
      const closeEvent = new CustomEvent(customEvents.closeMobilePrimaryNavTrigger);
      window.dispatchEvent(closeEvent);
    }
  }, [isOpen])

  const handleEventClose = () => (
    setIsOpen(false)
  )

  useEffect(() => {
    window.addEventListener(customEvents.closeWeatherWidgetTrigger, handleEventClose);
    return () => window.removeEventListener(customEvents.closeWeatherWidgetTrigger, handleEventClose);
  }, [])

  const handleSelectUnit = unit => {
    setSelectedUnit(unit);
    window.localStorage.setItem('aspen_weather_unit', unit);
  };

  if (!report.mountains?.length) {
    return null;
  }

  const {
    weather: { condition, temperature }
  } = report.mountains[0];

  return (
    <>
      <button
        className="weather-widget__trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen && !breakpoint.matches ? (
          <svg
            viewBox="0 0 246 246"
            className="weather-widget__trigger-close-icon"
          >
            <title>menu</title>
            <use xlinkHref="#close" />
          </svg>
        ) : (
          <>
            <span>
              {temperature.current[selectedUnit]}°{selectedUnit.toUpperCase()}
            </span>
            <svg className="weather-widget__trigger-icon">
              <title>weather</title>
              <use xlinkHref={`#${weatherIconMap[condition]}`} />
            </svg>
          </>
        )}
      </button>
      <Panel
        {...props}
        isOpen={isOpen}
        report={report}
        unit={selectedUnit}
        onUnitChange={handleSelectUnit}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

WeatherWidget.propTypes = {
  endpoint: PropTypes.string.isRequired
};

export default WeatherWidget;
